import React from 'react'
import PropTypes from 'prop-types'
import ConditionalHeader from '../ConditionalHeader/ConditionalHeader'
import KioskModeListener from '../KioskModeListener/KioskModeListener'
import { experienceNavPropTypes } from '../ExperienceNavControls/navigationItemPropType'

export default function ExperienceChrome({ activeExperienceId = 'none', listenForKiosk = true, ...navProps }) {
  return (
    <>
      <ConditionalHeader activeExperienceId={activeExperienceId} {...navProps} />
      {listenForKiosk && <KioskModeListener />}
    </>
  )
}

ExperienceChrome.propTypes = {
  activeExperienceId: PropTypes.string,
  listenForKiosk: PropTypes.bool,
  ...experienceNavPropTypes,
}
